import React from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { tooltipStyle, tooltip, ImgCell } from '@/components/TableCell';

const TableBox = ({
    evaluateTypes,
    onTableOperate,
}) => {

    const onOperateCell = (id, record) => {
        return <div className={styles.action}>
            <div
                className={styles.item}
                onClick={() => onTableOperate(id, record)}
            >编辑</div>
        </div>;
    };

    const scoreCell = (text, record) => {
        if (Number(text) > 0) {
            return tooltip(`+${text}`);
        } else {
            return tooltip(text);
        }
    };

    const columns = [
        {
            title: '星级',
            dataIndex: 'name',
            key: 'name',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '类型图标',
            dataIndex: 'imgUrl',
            key: 'imgUrl',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: ImgCell
        },
        {
            title: '等级分值',
            dataIndex: 'levelScore',
            key: 'levelScore',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: scoreCell
        },
        {
            title: '排序',
            dataIndex: 'sortNo',
            key: 'sortNo',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.id}
            columns={columns}
            dataSource={evaluateTypes}
            pagination={false}
            scroll={{ y: true }}
        />
    </div>;
};

TableBox.propTypes = {
    evaluateTypes: PropTypes.array,//表格数据
    onTableOperate: PropTypes.func,//表格操作
};
export default TableBox;